export const ERRORS = {
    INVALID_ACTION: 'Invalid Action',
    NO_TOKEN_PROVIDED: 'No token was provided',
    PAYPAL_OVERLAY_CLOSED: 'PayPal overlay closed',
    SUBMIT_NOT_SUPPORTED: 'Calling submit() is not supported for this payment method',
    WRONG_INSTANCE: 'The instance of the PayPal component being used is not the same which started the payment'
};
